<script lang="ts">
  import { onMount } from 'svelte'
  // on 2022-06-23 we have switched away from calling a rest endpoint in favor of
  // embeding all the data on the page in a html data attribute. So I am commenting out
  // un-needed code.
  //const devDomain = 'https://mbredcdev.wpengine.com'
  //const prodDomain = 'https://www.mbredc.org'
  //const endpoint = '/wp-json/wp/v2/partner?orderby=title&order=asc'
  //let path

  let partners = []
  $: locations =
    partners === []
      ? []
      : [...new Set(partners.map((partner) => partner?.location))]
  // let industries = []
  // $: industries =
  //   partners === []
  //     ? []
  //     : [...new Set(partners.map((partner) => partner?.industry))]
  let industriesMap = new Set(); 
  let industriesMapIt = Array.from(industriesMap);
  $: industries =
    partners === []
      ? []
      : [...new Set(partners.map((partner) => {
        var newVal = '';
        // For Arrays
        if(Array.isArray(partner?.industry)){
          partner?.industry.forEach(function(value){
            if (!industriesMap.has(value)) {
              industriesMap.add(value);
            }
          });
        }else{
          // For values
          if (!industriesMap.has(partner?.industry)){
            industriesMap.add(partner?.industry);
          }
        }
        industriesMapIt = Array.from(industriesMap);
        industriesMapIt.sort();
        return partner?.industry
      }))]
  let location = 'all'
  let industry = 'all'
  let member_level = 'all'
  let member_levels = [
    'Chairman',
    'Presidents',
    'Leadership',
    'Executive',
    'Supporting',
  ]

  function levelCount(partnerList, level) {
    return partnerList.filter((partner) => partner.donor_level === level).length
  }

  $: filteredPartners = partners.filter((partner) => {
    if (location !== 'all' && location !== partner.location) return false
    let partnerIndustry = [...partner?.industry]
    if (industry !== 'all' && !partnerIndustry.includes(industry)) return false
    if (member_level !== 'all' && member_level !== partner.donor_level)
      return false
    return true
  })

  onMount(async function () {
    // this function was rewritten to extract the data from the page
    let dataContainer = document.querySelector('#partner-grid-app')
    let dataSet = JSON.parse(dataContainer?.dataset?.params)
    //console.log(dataSet)
    partners = dataSet
    //if (document.domain === 'localhost') {
    //  path = devDomain + endpoint
    //} else if (document.domain === 'www.mbredc.org') {
    //  path = prodDomain + endpoint
    //} else {
    //  path = devDomain + endpoint
    //}
    //const response = await fetch(path)
    //console.log(response.headers.get('X-WP-TotalPages'))
    //console.log(response.headers.get('Link'))
    //const data = await response.json()
    //let allData = data
    //let totalPages = parseInt(response.headers.get('X-WP-TotalPages'))
    //let paginationLinks = response.headers.get('Link')
    //if (totalPages > 1) {
    //  for (let page = 2; page < totalPages + 1; page++) {
    //    //console.log(paginationLinks)
    //    const response = await fetch(`${path}&page=${page}`)
    //    const data = await response.json()
    //    allData = [...allData, ...data]
    //    paginationLinks = response.headers.get('Link')
    //  }
    //}
    //console.log(allData)
    //partners = alphabatizedData(cleanedData(allData))
  })

  function cleanedData(data) {
    // setup the data we want
    return data.map((partner) => {
      return {
        id: partner?.id,
        status: partner?.status,
        company_name: partner?.partner_company_name,
        donor_level: partner?.partner_donor_level,
        industry: partner?.partner_industry,
        location: partner?.partner_city,
        logo: partner?.thumbnail_url,
        link: partner?.link,
      }
    })
  }
  function alphabatizedData(data) {
    //alphabatize list by company name (it should already be, but we just making sure)
    return data.sort(function (a, b) {
      var textA = a.company_name.toUpperCase()
      var textB = b.company_name.toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
  }
</script>

<form class="partnersFilter">
  <div class="partnersFilter-wrapper">
    <div class="partnersFilter-fields">
      <h5 class="partnersFilter-title">Filter partner list:</h5>
      <label class="partnersFilter-label">
        <span>Location: </span>
        <select
          class="partnersFilter-input"
          name="location"
          bind:value={location}
        >
          <option value="all">All</option>
          {#each locations as loc}
            <option value={loc}>{loc}</option>
          {/each}
        </select>
      </label>
    </div>

    <div class="partnersFilter-fields">
      <label class="partnersFilter-label">
        <span>Industry: </span>
        <select
          class="partnersFilter-input"
          name="industry"
          bind:value={industry}
        >
          <option value="all">All</option>
          
          {#each industriesMapIt as ind}
            <option value={ind}>{ind}</option>
          {/each}
          <!-- <option value="Manufacturing">Manufacturing</option>
          <option value="Hospitality">Hospitality</option>
          <option value="Technology">Technology</option>
          <option value="Aerospace">Aerospace</option>
          <option value="Healthcare">Healthcare</option>
          <option value="Insurance">Insurance</option>
          <option value="Finance">Finance</option>
          <option value="Construction">Construction</option>
          <option value="Marine">Marine</option> -->
        </select>
      </label>
    </div>

    <div class="partnersFilter-fields">
      <label class="partnersFilter-label">
        <span>Member Level: </span>
        <select
          class="partnersFilter-input"
          name="member-level"
          bind:value={member_level}
        >
          <option value="all">All</option>
          <option value="Supporting">Supporting</option>
          <option value="Executive">Executive</option>
          <option value="Leadership">Leadership</option>
          <option value="Presidents">Presidents</option>
          <option value="Chairman">Chairman</option>
        </select>
      </label>
    </div>
  </div>
</form>

{#each member_levels as level}
  {#if member_level === 'all' || member_level === level}
    {#if member_level !== 'all' || (member_level === 'all' && levelCount(filteredPartners, level) > 0)}
      <section class="partners --silver">
        <header class="partners-header">
          <h3 class="partners-title sectionTitle">{level} Partners</h3>
        </header>

        <div class="partners-list">
          {#each filteredPartners as partner}
            {#if partner.donor_level === level}
              {#if 'logo' in partner}
                <div class="partner-item">
                  <a href={partner?.link}>
                    <img
                      src={partner?.logo}
                      alt={partner?.company_name + 'logo'}
                    />
                  </a>
                  <br />
                </div>
              {:else}
                <div class="partner-item">
                  <a href={partner?.link}>
                    {partner.company_name}
                  </a>
                </div>
              {/if}
            {/if}
          {/each}
        </div>
      </section>
    {/if}
  {/if}
{/each}

<style>
  .partnersFilter {
    font-family: Roboto, sans-serif;
    padding-top: 3.125rem;
    padding-bottom: 3.125rem;
    margin-bottom: 3.125rem;
    color: #fff;
    background-color: #191d35;
    display: block;
    margin-top: 0em;
  }
  .partnersFilter-wrapper {
    max-width: 71.25rem;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0.9375rem;
    padding-right: 0.9375rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 20px;
  }
  .partnersFilter-fields {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    flex: 1 0 100%;
    max-width: 100%;
    margin-bottom: 1.5625rem;
  }
  .partnersFilter-title {
    flex: 1 0 100%;
    font-size: 0.8125rem;
    font-weight: 400;
    margin-bottom: 0.9375rem;
  }
  .partnersFilter-label {
    position: relative;
    flex: 1 0 100%;
    max-width: 100%;
  }
  .partnersFilter-input {
    height: 2.5rem;
    box-shadow: none;
    border: 1px solid #ededed;
    padding-right: 0.625rem;
    font-size: 0.75rem;
    width: 100%;
  }
  .partnersFilter-fields.--submit {
    display: flex;
    justify-content: center;
    flex: 1 0 100%;
    max-width: 100%;
  }
  .button {
    font-size: 0.8125rem;
    font-weight: 500;
    padding: 0.75rem 1.875rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    text-align: center;
  }
  .button.--red,
  .setsOfContent-tabs > .button.--active {
    color: #fff;
    background-color: #990812;
    width: 100%;
  }
  .partners {
    padding-top: 1.5625rem;
    padding-bottom: 1.5625rem;
  }
  .partners-title {
    display: block;
    font-size: 1.17em;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-family: Roboto, san-serif;
  }
  .partners-list {
    display: grid;
    grid-template-columns: repeat(4, 25%);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    overflow: visible;
  }
  .partners-list > div {
    border-right: 1px solid gray;
    border-top: 1px solid gray;
  }
  .partners-list > .partner-item:nth-child(-n + 4) {
    border-top: 1px none;
  }
  .partners-list > .partner-item:nth-child(4n) {
    border-right: 1px none;
  }

  @media (max-width: 64em) {
    .partners-list {
      grid-template-columns: repeat(2, 50%);
    }
    .partners-list > .partner-item:nth-child(-n + 2) {
      border-top: 1px none;
    }
    .partners-list > .partner-item:nth-child(2n) {
      border-right: 1px none;
    }
  }

  .partner-item {
    padding: 15px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;

    text-align: center;
    transition: ease-in-out 250ms;
  }
  .partner-item:after {
    content: '\00a0';
    font-family: Roboto, san-serif;
    display: inline-block;
    color: #007fc5;
    font-weight: 700;
  }

  .partner-item:hover {
    transform: scale(1.05);
    background-color: rgb(247, 247, 247);
    border: none;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  }
  .partner-item:hover:after {
    content: 'Click to learn more.';
  }

  .partner-item img {
    display: inline-block;
    max-width: 100%;
    height: auto;
  }
  a {
    font-family: Roboto, san-serif;
  }
</style>
